module.exports = __webpack_public_path__ + "img/professor_avatar.880a1550.png";